import { PcbNodeHelper } from "../../../nodes";
import { getNodeExpressionEvaluationContext, getNodeLayoutExpressionEvaluationContext, getProjectExpressionEvaluationContext, } from "../../expression_engine";
import { LayerOrientation } from "../../rules";
import { PcbLayoutRuleCompiler } from "../rule_parsing_and_compilation";
import { PcbNodeBakedRulesDeriver } from "./PcbNodeBakedRulesDeriver";
export class PcbNodeBaker {
    documentState;
    treeManager;
    logger;
    pcbRuleCompiler;
    bakedRulesDeriver;
    constructor(documentState, globalRules, runtimeRulesManager, treeManager, logger) {
        this.documentState = documentState;
        this.treeManager = treeManager;
        this.logger = logger;
        this.pcbRuleCompiler = new PcbLayoutRuleCompiler(documentState.elements, documentState.nets, globalRules, 
        // NOTE: it is important that the compiler gets a reference to the
        // treeNodes from the manager that are mutated by the PcbLayoutEngine
        treeManager.treeNodes, documentState, runtimeRulesManager, logger);
        this.bakedRulesDeriver = new PcbNodeBakedRulesDeriver(treeManager, logger);
    }
    bakeNode(node) {
        const flattenedRules = this.pcbRuleCompiler.getFlattenedRules(node);
        if (flattenedRules?.layer?.value === LayerOrientation.invert) {
            // If layer is specified as "invert" then precalculate the value and
            // store back into flattenedRules, so that children inheriting the
            // value will inherit the absolute layer, not the "invert" value (which
            // would result in flipping layers for every child hereafter), but so
            // children can still specify their own "invert" value to invert the
            // layer again.
            //
            // TODO this would be much cleaner if the inherit functionality used
            // the *baked* value to inherit instead of the unparsed value. That would
            // be more like CSS (which inherits computed value) and would work better
            // for lots of things. We should do that, but avoiding a refactor for this
            // demo just to prove the feature.
            const parentNode = PcbNodeHelper.asBakedNode(this.treeManager.treeNodes[node.parentUid]);
            const parentLayer = parentNode?.bakedRules?.layer ?? LayerOrientation.top;
            // Don't implement mid-layer inverting now. However, if wanted, this could
            // be done with a sane algorithm: simply reverse the stackup order. So eg
            // midlayer 2 would end up as midlayer 1 on a 4-layer board.
            const invertedLayer = parentLayer === LayerOrientation.top ? LayerOrientation.bottom : LayerOrientation.top;
            flattenedRules.layer = { ...flattenedRules.layer, value: invertedLayer };
        }
        const expressionEvaluationContext = this.getBaseExpressionEvaluationContext(this.documentState, node, flattenedRules);
        const bakedRules = this.bakedRulesDeriver.getBakedRulesForNode(node, flattenedRules, this.documentState, expressionEvaluationContext);
        return {
            flattenedRules,
            bakedRules,
        };
    }
    getBaseExpressionEvaluationContext(documentState, node, flattenedRules) {
        const expressionEvaluationContext = {
            project: getProjectExpressionEvaluationContext(documentState),
            layout: node && node.uid
                ? getNodeLayoutExpressionEvaluationContext(node, {
                    ...documentState,
                    pcbLayoutNodes: this.treeManager.treeNodes,
                }, this.logger)
                : undefined,
            this: node
                ? getNodeExpressionEvaluationContext(node, flattenedRules, {
                    ...documentState,
                    pcbLayoutNodes: this.treeManager.treeNodes,
                }, this.logger)
                : undefined,
        };
        return expressionEvaluationContext;
    }
}
//# sourceMappingURL=PcbNodeBaker.js.map